import { useEffect, useState } from 'react';

/**
 * `true` when the viewport is at least `px` wide (matchMedia, live-updating).
 * Used where a surface must NOT MOUNT something below a breakpoint (e.g. the
 * finish screen's live-site iframe, INT-0028): a CSS `hidden xl:block` would
 * still load the iframe for every phone, so the decision has to be in JS.
 * Initial value is read synchronously so the first paint is already right.
 */
export function useMinWidth(px: number): boolean {
  const query = `(min-width: ${px}px)`;
  const [matches, setMatches] = useState<boolean>(() => {
    try {
      return typeof window !== 'undefined' && !!window.matchMedia(query).matches;
    } catch {
      return false;
    }
  });
  useEffect(() => {
    let mql: MediaQueryList;
    try {
      mql = window.matchMedia(query);
    } catch {
      return undefined;
    }
    const onChange = () => setMatches(!!mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
